import 'common';
import 'lazysizes';
import '../stylesheets/black_owned_businesses.css';

import(/* webpackChunkName: "Dropdown" */ 'dropdown').then(module => new module.Dropdown().mount());

import(/* webpackChunkName: "sideNav" */ 'side_nav').then(module => module.sideNav());

import(/* webpackChunkName: "Liberty" */ 'liberty').then(module => new module.Liberty().mount());

import(/* webpackChunkName: "AddressSearchForm" */ 'address_search_form').then(module =>
  new module.AddressSearchForm().mount(),
);

import(/* webpackChunkName: "dateTimeFieldsPickers" */ 'date_time_fields_pickers').then(module =>
  module.dateTimeFieldsPickers(),
);

import(/* webpackChunkName: "Accordion" */ 'accordion').then(module =>
  new module.Accordion().mount(),
);
